import { ReactNode } from "react";

export enum AccessEnum {
  ADMIN = 1,
  USER = 2,
  LOCAL_ADMIN = 3,
  NO_ROLE = 4,
}

export type NavMenuType = {
  id: string;
  pathname: string;
  title: string;
  icon: ReactNode;
  isExpand?: boolean;
  expandElement?: ReactNode;
  access?: AccessEnum[];
  isDisabled?: boolean;
};
